<script setup lang="ts">
import BrandLogo from './BrandLogo.vue';
import ThemeToggle from './ThemeToggle.vue';

defineProps<{
  /** Ключ текущей страницы для подсветки активного пункта меню */
  current: string;
}>();

const emit = defineEmits<{ (e: 'open-menu'): void }>();

const navLinks = [
  { key: 'home', href: '/', label: 'Главная' },
  { key: 'requirements', href: '/requirements.html', label: 'Документы и требования' },
  { key: 'about', href: '/about.html', label: 'О компании' },
];
</script>

<template>
  <header class="site-header">
    <div class="container header-inner">
      <a href="/" class="logo-link" aria-label="ТКапитал — главная">
        <BrandLogo :size="34" show-text />
      </a>

      <nav class="main-nav" aria-label="Основная навигация">
        <a
          v-for="link in navLinks"
          :key="link.key"
          :href="link.href"
          :class="{ 'is-active': link.key === current }"
          :aria-current="link.key === current ? 'page' : undefined"
        >
          {{ link.label }}
        </a>
      </nav>

      <div class="header-actions">
        <a href="tel:+375339933338" class="phone-link">+375 33 993-33-38</a>
        <ThemeToggle />
        <button
          class="hamburger"
          type="button"
          aria-label="Открыть меню"
          @click="emit('open-menu')"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="17" x2="20" y2="17" />
          </svg>
        </button>
      </div>
    </div>
  </header>
</template>
